import * as React from 'react';
import moment from 'moment-timezone';
import { connect } from 'react-redux';
import { RootState } from '../../app/store';
import { BookingResponseType } from '../../redux/booking/booking';
import { TIMEZONE } from '../../utils/constants';

import car from '../../images/car.svg';
import sadCar from '../../images/sadCar.svg';
import error from '../../images/error.svg';

import './ConfirmationDetails.css';

interface InjectedProps {
    product?: endpoints.ProductDTO;
    pickupLocation?: string;
    date?: Date;
    bookingResponseType?: number;
    confirmationCode?: string;
    paymentEmail?: string;
    bookingEmail?: string;
    instructor?: endpoints.Instructor;
}

export type Props = InjectedProps;

export class ConfirmationDetails extends React.PureComponent<Props> {

    render() {
        const { product, pickupLocation, date, confirmationCode,
            bookingResponseType, paymentEmail, bookingEmail, instructor } = this.props;
        const successful = bookingResponseType !== undefined && bookingResponseType === BookingResponseType.Success;
        return (
            <div className="confirmationDetails-container">
                <div className="confirmationDetails-header">
                    {successful &&
                        <img className="car-image" src={car} alt="Car"/>
                    }
                    {!successful &&
                        <img className="car-image" src={sadCar} />
                    }
                    <h3 className="package-name"><strong>{product && product.description} Package</strong></h3>
                </div>
                {bookingResponseType === BookingResponseType.LessonError &&
                    <div>
                        <img src={error} />
                        <div>
                            <h3 className="error-text"><strong>
                                Your pickup time and location have not been confirmed
                            </strong></h3>
                        </div>
                        <span className="error-text">
                            Please call our Driving School team in Galway on
                            <a href="tel:1800663663"> 1800 663663</a> who will confirm your pickup
                            time and location.
                        </span>
                    </div>
                }
                {bookingResponseType === BookingResponseType.DetailsError &&
                    <div>
                        <img src={error} />
                        <div>
                            <h3 className="error-text"><strong>
                                Please call our Team on <a href="tel:1800663663"> 1800 663663</a>
                            </strong></h3>
                        </div>
                        <span className="error-text">
                            A member of our Driving School team in Galway will be able to assist you.
                        </span>
                    </div>
                }
                {!successful &&
                    <div className="confirmationDetails__paymentStatus">
                        <span><strong>Your payment has been successful</strong></span>
                    </div>
                }
                <table className="booking-details">
                    <tbody>
                        {successful &&
                            <tr>
                                <td>Pickup Location:</td>
                                <td><strong>{pickupLocation}</strong></td>
                            </tr>
                        }
                        {successful &&
                            <tr>
                                <td>Date:</td>
                                <td><strong>{moment(date).tz(TIMEZONE).format('dddd Do MMMM YYYY')}</strong></td>
                            </tr>
                        }
                        {successful &&
                            <tr>
                                <td>Time:</td>
                                <td><strong>{moment(date).tz(TIMEZONE).format('h:mmA')}</strong></td>
                            </tr>
                        }
                        <tr>
                            <td>
                                {bookingResponseType === BookingResponseType.DetailsError
                                    ? 'Authorisation Code:' : 'Confirmation Number:'
                                }
                            </td>
                            <td><strong>{confirmationCode}</strong></td>
                        </tr>
                        <tr>
                            <td>Payment:</td>
                            <td><strong>€{product && product.price}</strong></td>
                        </tr>
                        {successful && instructor &&
                            <tr>
                                <td>Instructor's Name:</td>
                                <td><strong>{instructor.instructorName}</strong></td>
                            </tr>
                        }
                        {successful && instructor &&
                            <tr>
                                <td>Instructor's Number:</td>
                                <td><strong>{instructor.mobilePhoneNumber}</strong></td>
                            </tr>
                        }
                        {(successful || bookingResponseType === BookingResponseType.LessonError) && paymentEmail &&
                            <tr>
                                <td>Payment Email Recipient:</td>
                                <td><strong>{paymentEmail}</strong></td>
                            </tr>
                        }
                        {successful && bookingEmail &&
                            <tr>
                                <td>Booking Email Recipient:</td>
                                <td><strong>{bookingEmail}</strong></td>
                            </tr>
                        }
                    </tbody>
                </table>
            </div>
        );
    }
}

export function mapStateToProps(state: RootState) {
    const { userSelection, booking, payment } = state;
    const { location, productId, pupilDetails } = userSelection;
    const bookingResponse = booking.bookingResponse;
    const paymentResponse = payment.paymentResponse;
    return {
        product: productId ? state.products.availableProducts[productId] : undefined,
        pickupLocation: location && location.locality,
        date: state.userSelection.lessonTime,
        confirmationCode: bookingResponse && bookingResponse.code
            || paymentResponse && atob(paymentResponse.responseObj.AUTHCODE),
        bookingResponseType: booking.bookingResponseType,
        bookingEmail: pupilDetails ? pupilDetails.pupil.email : undefined,
        paymentEmail: pupilDetails ?
            (pupilDetails.thirdParty ? pupilDetails.thirdParty.email : pupilDetails.pupil.email) : undefined,
        instructor: bookingResponse && bookingResponse.instructor
    };
}

export default connect<InjectedProps, {}>(mapStateToProps)(ConfirmationDetails);